import Box from './Box';
import styled from 'styled-components/macro';

const SectionWrapper = styled(Box)`
  width: 100%;
  height: ${({ height }) => height || '100%'};
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid white;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
`;

export default SectionWrapper;
